import { inject, Pipe, PipeTransform } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MerchantsService } from '../../core/services/merchants.service';
import { CurrencyPipe } from '@angular/common';

@Pipe({
  name: 'merchantCurrency',
})
export class MerchantCurrencyPipe implements PipeTransform {
  private merchantsService = inject(MerchantsService);

  public currentMerchant = toSignal(this.merchantsService.activeMerchant);
  private merchantCurrency = this.currentMerchant()?.currency || 'EUR';
  private currencyPipe = new CurrencyPipe('pt-PT');

  transform(value: number, display: 'symbol' | 'code' | 'symbol-narrow' | string = 'symbol-narrow', currencyOverride?: string): unknown {
    // Use currency override if provided, otherwise use merchant currency
    const currency = currencyOverride || this.merchantCurrency;
    // Only show decimals if they exist
    const digitsInfo = Number.isInteger(value) ? '1.0-0' : '1.2-2';
    const formatted = this.currencyPipe.transform(value, currency, display, digitsInfo);
    if (!formatted) return null;

    // Move symbol to the end, regardless of which symbol is used
    const symbolMatch = formatted.match(/[^\d.,\s-]+/);
    const symbol = symbolMatch ? symbolMatch[0] : '';
    const amount = formatted
      .replace(symbol, '')
      .trim()
      .replace(/^[-−]\s+/, '-');

    return amount + (symbol ? symbol : '');
  }
}
